import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-252" data-mp="qlqw02y4w230">
      <HeroSection data-id="element-253" data-mp="llw53zeczchy" />
      <ProofSection data-id="element-254" data-mp="lmeb3nqtp532" />
      <ProblemSection data-id="element-255" data-mp="lmxrh00trlez" />
      <SystemSection data-id="element-256" data-mp="lnpehmgcwatn" />
      <ModulesSection data-id="element-257" data-mp="2zix9rk2cjm13" />
      <BonusSection data-id="element-258" data-mp="2zjq5zr3oit4z" />
      <UrgencySection data-id="element-259" data-mp="2zk8a19wl2bng" />
      <PricingSection data-id="element-260" data-mp="2zkrr6oeesw0f" />
      <TestimonialsSection data-id="element-261" data-mp="33kigenoaf42u" />
      <GuaranteeSection data-id="element-262" data-mp="33jqwwb7yswsx" />
      <FAQSection data-id="element-263" data-mp="33l1z46lrhwhx" />
      <FinalCTA data-id="element-264" data-mp="33ifry82s9j08" />
      <Footer data-id="element-265" data-mp="38jlmmbg07gce" />
    </main>;
}